import React, { useState } from "react";

/**
 * Displays a staging probe result with optional copy-to-clipboard.
 */
export default function StagingTestResult({ result, label }) {
  const [copied, setCopied] = useState(false);

  if (!result) return null;

  const text = JSON.stringify(
    {
      label,
      ...result,
    },
    null,
    2
  );

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(text);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch {
      setCopied(false);
    }
  };

  return (
    <div
      className={`cs-staging-result${result.ok ? " cs-staging-result--ok" : " cs-staging-result--fail"}`}
    >
      <div className="cs-staging-result__header">
        <strong>{label || `${result.method} ${result.path}`}</strong>
        <span>
          {result.status} {result.ok ? "OK" : "FAIL"}
        </span>
        <button type="button" className="cs-link-btn" onClick={handleCopy}>
          {copied ? "Copied" : "Copy result"}
        </button>
      </div>
      <dl className="cs-staging-result__meta">
        <dt>URL</dt>
        <dd>
          <code>{result.fullUrl}</code>
        </dd>
        <dt>CSRF readable in JS</dt>
        <dd>{result.csrfCookiePresent ? "Yes" : "No"}</dd>
        <dt>X-CSRFToken sent</dt>
        <dd>{result.csrfHeaderSent ? "Yes" : "No"}</dd>
        <dt>Credentials</dt>
        <dd>{result.credentialsIncluded ? "include" : "—"}</dd>
        <dt>Time</dt>
        <dd>{result.timestamp}</dd>
        {result.errorMessage ? (
          <>
            <dt>Error</dt>
            <dd>{result.errorMessage}</dd>
          </>
        ) : null}
      </dl>
      <pre className="cs-staging-result__body">
        {JSON.stringify(result.data, null, 2) || "(empty body)"}
      </pre>
    </div>
  );
}
